import { ArcadeRoomListEntry } from 'arcade/sections/rooms/list/ArcadeRoomListEntry';
import React, { Component } from 'react';
import { Grid } from 'shared/grid';
import { Room } from 'shared/interfaces';

interface ArcadeRoomListProps {
    readonly arcadeId: string;
    readonly mainRoomId: string;
    readonly rooms: Array<Room>;
    readonly getArcadeRooms: (arcadeId: string) => Promise<void>;
    readonly getArcadeRoom: (roomId: string) => Promise<void>;
    readonly deleteArcadeRoom: (roomId: string) => Promise<void>;
}

export default class ArcadeRoomList extends Component<ArcadeRoomListProps> {
    static defaultProps: Partial<ArcadeRoomListProps> = {
        rooms: []
    };

    constructor(props: ArcadeRoomListProps) {
        super(props);
        this.props.getArcadeRooms(props.arcadeId);
    }

    render () {
        const {
            rooms,
            mainRoomId
        } = this.props;

        if (!rooms.length) {
            return <p>No arcade rooms.</p>;
        }

        const tiles = rooms.map(room =>
            <ArcadeRoomListEntry
                key={room.id}
                onDelete={room.id === mainRoomId ? undefined : this.props.deleteArcadeRoom}
                onEdit={this.props.getArcadeRoom}
                room={room}
            />
        );

        return <Grid className="arcade-games-lists-wrapper">{tiles}</Grid>;
    }
}
